function HeadingImage({ style }) {
  return <div className={style}></div>;
}

export default HeadingImage;
